const prepareFilter = (obj) => {
  Object.entries(obj).forEach(
    ([key, value]) => (obj[key] = { value: value, text: value })
  );
  return obj;
};

export default prepareFilter;
